import Complex from "./Complex";

var iteratePoint = function(z, c) {
	return Complex.add(Complex.square(z), c);
}

var iterateMany = function(zMatrix, cMatrix, escapeMatrix, unescaped, iterations) {
	var unescapedNext = [];
	var newlyEscaped = [];
	for (var point of unescaped) {
		var i = point[0];
		var j = point[1];

		var c = Array.isArray(cMatrix) ? cMatrix[i][j] : cMatrix;
		zMatrix[i][j] = iteratePoint(zMatrix[i][j], c);

		if (Complex.modulusSquared(zMatrix[i][j]) > 4) {
			escapeMatrix[i][j] = iterations;
			newlyEscaped.push([i, j]);
		} else {
			unescapedNext.push([i, j]);
		}
	}
	return { zMatrix: zMatrix, escapeMatrix: escapeMatrix, unescaped: unescapedNext, newlyEscaped: newlyEscaped };
}

var initialiseMatrices = function(c,centre,scale,dimensions) {
	var matrices = {
		zMatrix:[],
		cMatrix:[],
		escapeMatrix:[],
		unescaped:[]
	};
	for (var i = 0; i < dimensions.width; i++) {
	  // Initialize arrays and set initial values
	  matrices.zMatrix[i] = [];
	  matrices.escapeMatrix[i] = [];
	  if (c === null) matrices.cMatrix[i] = [];
	  for (var j = 0; j < dimensions.height; j++) {
		if (c === null) {
		  matrices.zMatrix[i][j] = { r: 0, i: 0 };
		} else {
		  matrices.zMatrix[i][j] = Complex.pixelToComplex(i, j, dimensions, centre, scale);
		}
		matrices.escapeMatrix[i][j] = 0;
		if (c === null) matrices.cMatrix[i][j] = Complex.pixelToComplex(i, j, dimensions, centre, scale);
		matrices.unescaped.push([i, j]);
	  }
	}

	if (c !== null) matrices.cMatrix = c;
	return matrices
};

var compute = function(iterations, c, centre, scale, dimensions) {
	var matrices = initialiseMatrices(c,centre,scale,dimensions);
	var { zMatrix, cMatrix, escapeMatrix, unescaped } = matrices;
	for (var i = 1; i <= iterations; i++) {
		var matrices = iterateMany(zMatrix, cMatrix, escapeMatrix, unescaped, i);
		zMatrix = matrices.zMatrix;
		escapeMatrix = matrices.escapeMatrix;
		unescaped = matrices.unescaped;
	}
	return escapeMatrix;
}

var encodeColour = function(quotient, options) {
	// Calculate the hue position in the cycle
	var hue = Math.pow(quotient,options.exponent) * options.cycle;

	// Calculate the individual color components
	var red = Math.round(Math.sin((hue + options.redOffset) * (Math.PI / 3)) * 127 + 128);
	var green = Math.round(Math.sin((hue + options.greenOffset) * (Math.PI / 3)) * 127 + 128);
	var blue = Math.round(Math.sin((hue + options.blueOffset) * (Math.PI / 3)) * 127 + 128);

	// Combine the components into an RGB color value
	var colour = `rgb(${red}, ${green}, ${blue})`;
	return colour;
}

var getNextEscapeCount = function(cumulativeEscapeCount, newlyEscapedCount) {
  for (var i in cumulativeEscapeCount) {
    cumulativeEscapeCount[i]=cumulativeEscapeCount[i]-newlyEscapedCount;
  }
  cumulativeEscapeCount.push(cumulativeEscapeCount[cumulativeEscapeCount.length-1]+newlyEscapedCount); 
  return cumulativeEscapeCount;
}

var getEscapeCount = function(escapeMatrix, iterations) {
  var escapeCount = [];
  var cumulativeEscapeCount = [0];
  var pixelsToPlot = 0;

  for (var i = 0; i <= iterations; i++) {
    escapeCount.push(0);
  }

  for (var i in escapeMatrix) {
    for (var j in escapeMatrix[i]) {
      escapeCount[escapeMatrix[i][j]] = escapeCount[escapeMatrix[i][j]] + 1;
    }
  }

  for (var i = 0; i <= iterations; i++) {
    pixelsToPlot += escapeCount[i];
    cumulativeEscapeCount[i] = pixelsToPlot;
  }

  return cumulativeEscapeCount; 
}

var buildPalette = function(cumulativeEscapeCount, colourOptions) {
	var colourCache = [];
	for (var i = 1; i <= cumulativeEscapeCount.length; i++) {
      var quotient = cumulativeEscapeCount[i] / cumulativeEscapeCount[cumulativeEscapeCount.length-1];
      colourCache[i] = encodeColour(quotient, colourOptions);
    }
	return colourCache;
}

var draw = function(escapeMatrix, iterations, ctx, palette) {
  var height = escapeMatrix.length;
  var width = escapeMatrix[0].length;
  var imageData = ctx.createImageData(width, height);
  var data = imageData.data;
  
  for (var i = 0; i < width; i++) {
    for (var j = 0; j < height; j++) {
      var pixelIndex = (j * width + i) * 4;
      
      if (!escapeMatrix[i][j]) {
        // Black for non-escaped points
        data[pixelIndex] = 0;     // R
        data[pixelIndex + 1] = 0; // G
        data[pixelIndex + 2] = 0; // B
        data[pixelIndex + 3] = 255; // A
      } else {
        var colour = palette[escapeMatrix[i][j]];
        // Parse the RGB values from "rgb(r, g, b)" format
        var rgb = colour.match(/\d+/g);
        data[pixelIndex] = parseInt(rgb[0]);     // R
        data[pixelIndex + 1] = parseInt(rgb[1]); // G
        data[pixelIndex + 2] = parseInt(rgb[2]); // B
        data[pixelIndex + 3] = 255;              // A
      }
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
};

var drawIteration = function(pixels, ctx, colour) {
  ctx.fillStyle = colour;
  // Plot the pixels on the canvas for the specified iteration value
  for (var i in pixels) {
    ctx.fillRect(pixels[i][0], pixels[i][1], 1, 1);
  }
};

export default {
	compute,
	draw,
	iterateMany,
	initialiseMatrices,
	getEscapeCount,
	getNextEscapeCount,
	buildPalette
}